module.exports = __webpack_public_path__ + "static/media/time-off-card.1715fdb1.svg";